import ReactGA from "react-ga4"

let GA_INITIALIZED = false

export const isAnalyticsEnabled = () =>
  process.env.NODE_ENV !== "development" &&
  !!process.env.REACT_APP_GA4_CLIENT_ID

export const getGAId = () => {
  return process.env.REACT_APP_GA4_CLIENT_ID || null
}

export const initializeAnalytics = () => {
  if (!isAnalyticsEnabled()) return false
  const gaId = getGAId()
  if (!gaId) return false

  ReactGA.initialize(gaId)
  GA_INITIALIZED = true
  return true
}

/**
 * Single unified event tracker.
 *
 * Usage:
 *   trackEvent('select_date', { selected_date: '2025-09-22', ... })
 *   trackEvent('purchase', { transaction_id: '12345', ... })
 */
export const trackEvent = (eventName, params = {}) => {
  if (!GA_INITIALIZED) return

  try {
    ReactGA.event(eventName, {
      ...params,
      whitelabel:
        process.env.REACT_APP_GA_LABEL ||
        process.env.REACT_APP_WHITELABEL ||
        "unknown",
      ts_iso: new Date().toISOString()
    })
  } catch (e) {
    console.warn("Analytics tracking failed:", e)
  }
}
